
import React from 'react';

interface SectionTitleProps {
  title: string;
  onChange: (title: string) => void;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title, onChange }) => {
  return (
    <div className="mb-6">
      <input
        value={title}
        onChange={(e) => onChange(e.target.value)}
        className="w-full text-xl font-medium border-none focus:outline-none focus:ring-0"
        placeholder="Abschnittstitel (erforderlich)"
      />
    </div>
  );
};

export default SectionTitle;
